/**
 * meowyeah Five Elements Quiz
 * Calculates primary element from birth year.
 * and secondary element from birth month (seasonal associations).
 * Recommendations follow the nourishing cycle.
 */
(function() {
  'use strict';

  // ---- Data ----
  var wuxingData = {
    wood: {
      tagline: 'For the restless mind', support: 'water',
      name: 'Wood', code: 'WOOD', emoji: '🌿',
      color: '#4A7349', bgColor: '#E8F5E9', watermark: 'WOOD',
      desc: 'You carry the energy of growth and renewal. Like a tree, you are resilient, creative, and always reaching upward. Wood energy traditionally represents vision, kindness, and the power of new beginnings.',
      traits: ['Creative', 'Visionary', 'Compassionate', 'Resilient'],
      rec: 'Pearl',
      reason: 'Water nourishes Wood. Pearl, born in the depths of the sea, traditionally carries Water energy — its gentle, flowing essence is said to nurture your creative growth like rain feeding a forest.',
      cat: 'pearl'
    },
    fire: {
      tagline: 'For the ones who love hard', support: 'wood',
      name: 'Fire', code: 'FIRE', emoji: '🔥',
      color: '#D64933', bgColor: '#FFF3E0', watermark: 'FIRE',
      desc: 'You radiate warmth and passion. Fire energy is dynamic, inspiring, and transformative. You light up the room and traditionally carry the spark of leadership, joy, and bold self-expression.',
      traits: ['Passionate', 'Charismatic', 'Courageous', 'Joyful'],
      rec: 'Hetian Jade',
      reason: 'Wood feeds Fire. Jade, with its verdant energy of growth and life, is traditionally said to sustain your inner flame — like living wood that keeps the hearth burning bright.',
      cat: 'jade'
    },
    earth: {
      tagline: 'For those building something', support: 'fire',
      name: 'Earth', code: 'EARTH', emoji: '🏔️',
      color: '#C49944', bgColor: '#FFF8E1', watermark: 'EARTH',
      desc: 'You are grounded and nurturing. Earth energy brings stability, patience, and a deep sense of care for others. You are the foundation — reliable, thoughtful, and endlessly generous.',
      traits: ['Nurturing', 'Stable', 'Thoughtful', 'Generous'],
      rec: 'Southern Red Agate',
      reason: 'Fire creates Earth. Southern Red Agate, with its deep cinnabar warmth, is traditionally said to strengthen your foundation — like volcanic fire forging solid ground beneath your feet.',
      cat: 'agate'
    },
    metal: {
      tagline: 'For those who need protecting', support: 'earth',
      name: 'Metal', code: 'METAL', emoji: '⚔️',
      color: '#8A7F72', bgColor: '#F3E5F5', watermark: 'METAL',
      desc: 'You possess clarity and inner strength. Metal energy is precise, disciplined, and refined under pressure. You value truth, structure, and the beauty of things done with intention.',
      traits: ['Disciplined', 'Decisive', 'Refined', 'Loyal'],
      rec: 'Beeswax Amber',
      reason: 'Earth bears Metal. Amber, ancient resin crystallized within the earth over millions of years, is traditionally said to enrich your inner strength — like minerals forged deep in the mountain.',
      cat: 'amber'
    },
    water: {
      tagline: 'For those who feel everything', support: 'water',
      name: 'Water', code: 'WATER', emoji: '💧',
      color: '#4A6FA5', bgColor: '#E3F2FD', watermark: 'WATER',
      desc: 'You flow with wisdom and adaptability. Water energy is deep, intuitive, and quietly powerful. You navigate life with grace, finding paths where others see walls.',
      traits: ['Wise', 'Intuitive', 'Adaptive', 'Reflective'],
      rec: 'Pearl',
      reason: 'Water strengthens Water. Pearl, born in the depths of the sea, shares your element — its calm, luminous energy is traditionally said to deepen your natural wisdom and intuition.',
      // TODO when the Metal line launches: support: 'metal', rec: '<Metal stone>', reason: 'Metal enriches Water. ...', cat: 'metal'
      cat: 'pearl'
    }
  };

  // Map collection keys to Shopify collection handles
  var collectionUrls = {
    agate: '/collections/southern-red-agate',
    jade: '/collections/hetian-jade',
    amber: '/collections/beeswax-amber',
    pearl: '/collections/freshwater-pearl'
  };

  // Try to read collection URLs from section settings (data attributes on the section)
  (function() {
    var section = document.querySelector('[data-wuxing-quiz-settings]') || document.querySelector('.mw-section-wuxing-quiz');
    if (!section) return;
    var agateLink = section.getAttribute('data-agate-link');
    var jadeLink = section.getAttribute('data-jade-link');
    var amberLink = section.getAttribute('data-amber-link');
    var pearlLink = section.getAttribute('data-pearl-link');
    if (agateLink) collectionUrls.agate = agateLink;
    if (jadeLink) collectionUrls.jade = jadeLink;
    if (amberLink) collectionUrls.amber = amberLink;
    if (pearlLink) collectionUrls.pearl = pearlLink;
  })();

  var dualDescs = {
    'wood-wood': 'Double Wood energy makes you exceptionally creative and growth-oriented. You are a natural visionary with deep compassion, always planting seeds for the future.',
    'wood-fire': 'Wood feeds Fire — your creativity ignites into passionate action. You dream big and have the drive to make it real, inspiring everyone around you.',
    'wood-earth': 'Wood rooted in Earth gives you visionary ideas grounded in practicality. You dream with your feet on the ground, combining imagination with reliability.',
    'wood-metal': 'Wood and Metal create dynamic tension — your creativity is sharpened by discipline. You bring both artistic vision and precise execution to everything you do.',
    'wood-water': 'Wood nourished by Water makes you deeply intuitive and endlessly creative. Your ideas flow naturally, and your emotional depth gives them meaning.',
    'fire-wood': 'Fire fueled by Wood energy gives you both passion and creative vision. You inspire others with your warmth while always growing toward new horizons.',
    'fire-fire': 'Double Fire energy makes you magnetic and unstoppable. Your passion runs deep and your charisma lights up every room — you are a born leader.',
    'fire-earth': 'Fire tempered by Earth gives you passion with patience. Your warmth is grounded and reliable — people trust both your energy and your steadiness.',
    'fire-metal': 'Fire and Metal together forge something extraordinary. Your passion is focused and disciplined, creating work of lasting precision and beauty.',
    'fire-water': 'Fire and Water balance each other beautifully. Your passion is tempered by wisdom, giving you both the courage to act and the depth to reflect.',
    'earth-wood': 'Earth enriched by Wood energy combines your natural stability with creative growth. You build lasting foundations while always nurturing new possibilities.',
    'earth-fire': 'Earth warmed by Fire gives you both grounding and passion. You are nurturing yet dynamic — a stable force that radiates warmth to those around you.',
    'earth-earth': 'Double Earth energy makes you exceptionally grounded and generous. You are the ultimate foundation — patient, wise, and endlessly supportive.',
    'earth-metal': 'Earth and Metal together create enduring strength. You combine nurturing care with clear principles, building things that stand the test of time.',
    'earth-water': 'Earth and Water together give you both stability and depth. You are grounded yet intuitive, combining practical wisdom with emotional intelligence.',
    'metal-wood': 'Metal and Wood create creative tension — your discipline is softened by compassion. You bring both structure and heart to everything you build.',
    'metal-fire': 'Metal refined by Fire gives you clarity forged in passion. You are decisive and warm, combining inner strength with inspiring energy.',
    'metal-earth': 'Metal supported by Earth gives you discipline rooted in patience. Your principles are unshakable because they come from genuine care and thoughtfulness.',
    'metal-metal': 'Double Metal energy makes you exceptionally focused and principled. Your clarity of purpose and inner strength are truly remarkable.',
    'metal-water': 'Metal and Water flow together beautifully. Your discipline is guided by deep intuition, giving you both precision and profound wisdom.',
    'water-wood': 'Water nourishing Wood gives you deep wisdom that fuels creative growth. Your intuitive understanding helps you see possibilities others miss.',
    'water-fire': 'Water and Fire create beautiful balance — depth meets warmth. Your wisdom is expressed through passion, making you both thoughtful and inspiring.',
    'water-earth': 'Water and Earth together give you flowing adaptability with solid grounding. You navigate change gracefully while maintaining your center.',
    'water-metal': 'Water guided by Metal gives you intuition sharpened by clarity. Your deep wisdom is expressed with precision, making your insights truly powerful.',
    'water-water': 'Double Water energy makes you profoundly intuitive and wise. You see the deeper currents in life and navigate them with effortless grace.'
  };

  // ---- Element calculation ----
  function getElement(year,month,day){var y=parseInt(year),m=parseInt(month),d=parseInt(day)||15;if(m<2||(m===2&&d<4))y-=1;var s=((y%10)+10)%10;return s===0||s===1?"metal":s===2||s===3?"water":s===4||s===5?"wood":s===6||s===7?"fire":"earth"}

  function getMonthElement(month,day){var m=parseInt(month),d=parseInt(day)||15,starts=[6,4,6,5,6,6,7,8,8,8,7,7],map=["earth","wood","wood","earth","fire","fire","earth","metal","metal","earth","water","water"],i=d>=starts[m-1]?m-1:m-2;if(i<0)i=11;return map[i]}

  // ---- DOM setup ----
  function init() {
    var yearSel = document.getElementById('wxYear');
    var monthSel = document.getElementById('wxMonth');
    var daySel = document.getElementById('wxDay');
    var submitBtn = document.getElementById('wuxingSubmit');
    var retryBtn = document.getElementById('wuxingRetry');

    if (!yearSel || !submitBtn) return;

    // Populate year
    var html = '<option value="">Select</option>';
    var now = new Date().getFullYear();
    for (var y = now - 10; y >= 1940; y--) {
      html += '<option value="' + y + '">' + y + '</option>';
    }
    yearSel.innerHTML = html;

    // Update days based on month/year
    function updateDays() {
      var month = parseInt(monthSel.value) || 0;
      var year = parseInt(yearSel.value) || 2000;
      var maxDay = 31;
      if (month) maxDay = new Date(year, month, 0).getDate();
      var prev = daySel.value;
      var h = '<option value="">Select</option>';
      for (var d = 1; d <= maxDay; d++) {
        h += '<option value="' + d + '"' + (d === parseInt(prev) ? ' selected' : '') + '>' + d + '</option>';
      }
      daySel.innerHTML = h;
    }
    updateDays();
    monthSel.addEventListener('change', updateDays);
    yearSel.addEventListener('change', updateDays);

    // Submit
    submitBtn.addEventListener('click', function() {
      var year = yearSel.value;
      var month = monthSel.value;
      var day = daySel.value;
      if (!year || !month || !day) {
        alert('Please select your birth date');
        return;
      }
      calcWuxing(parseInt(year), month, day);
    });

    // Retry
    if (retryBtn) {
      retryBtn.addEventListener('click', function() {
        document.getElementById('wuxingForm').style.display = 'block';
        document.getElementById('wuxingResult').classList.remove('show');
        window.scrollTo({ top: document.getElementById('wuxingForm').offsetTop - 80, behavior: 'smooth' });
      });
    }
  }

  function calcWuxing(year, month, day) {
    var priKey = getElement(year,month,day);
    var secKey = getMonthElement(month,day);
    var pri = wuxingData[priKey];
    var sec = wuxingData[secKey];

    // Watermark & info
    document.getElementById('wxResWatermark').textContent = pri.watermark;
    document.getElementById('wxResCn').textContent = pri.name + ' + ' + sec.name + ' · ' + year + '.' + month + '.' + day;

    // Primary element
    document.getElementById('wxPriIcon').innerHTML = pri.emoji;
    document.getElementById('wxPriIcon').style.background = pri.bgColor;
    document.getElementById('wxPriName').textContent = pri.name;
    var priTraits = '';
    pri.traits.forEach(function(t) { priTraits += '<span>' + t + '</span>'; });
    document.getElementById('wxPriTraits').innerHTML = priTraits;

    // Secondary element
    document.getElementById('wxSecIcon').innerHTML = sec.emoji;
    document.getElementById('wxSecIcon').style.background = sec.bgColor;
    document.getElementById('wxSecName').textContent = sec.name;
    var secTraits = '';
    sec.traits.forEach(function(t) { secTraits += '<span>' + t + '</span>'; });
    document.getElementById('wxSecTraits').innerHTML = secTraits;

    // Combo description
    var comboKey = priKey + '-' + secKey;
    document.getElementById('wxResDesc').textContent = dualDescs[comboKey] || pri.desc;

    // Recommendations
    function supportLine(el) {
      var sp = wuxingData[el.support];
      return 'Your supporting element: <strong>' + sp.name + '</strong> — <em>' + sp.tagline.charAt(0).toLowerCase() + sp.tagline.slice(1) + '</em>';
    }
    var sup1 = document.getElementById('wxRecSupport1');
    if (sup1) sup1.innerHTML = supportLine(pri);
    document.getElementById('wxRecStone1').textContent = pri.rec;
    document.getElementById('wxRecStone1').style.color = pri.color;
    document.getElementById('wxRecReason1').textContent = pri.reason;
    document.getElementById('wxRecBtn1').href = collectionUrls[pri.cat] || '/collections/all';

    var recSec = document.getElementById('wxRecSec');
    if (priKey === secKey) {
      recSec.style.display = 'none';
      document.querySelector('.mw-wuxing-rec-grid').style.gridTemplateColumns = '1fr';
    } else {
      recSec.style.display = '';
      document.querySelector('.mw-wuxing-rec-grid').style.gridTemplateColumns = '1fr 1fr';
      var sup2 = document.getElementById('wxRecSupport2');
      if (sup2) sup2.innerHTML = supportLine(sec);
      document.getElementById('wxRecStone2').textContent = sec.rec;
      document.getElementById('wxRecStone2').style.color = sec.color;
      document.getElementById('wxRecReason2').textContent = sec.reason;
      document.getElementById('wxRecBtn2').href = collectionUrls[sec.cat] || '/collections/all';
    }

    document.getElementById('wuxingResultCard').style.borderColor = pri.color;

    // Show result, hide form
    document.getElementById('wuxingForm').style.display = 'none';
    var result = document.getElementById('wuxingResult');
    result.classList.add('show');
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
